/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {
	Box,
	IconButton,
	Divider,
	Flex,
	Text,
	InputRightElement,
	InputGroup,
	Skeleton,
	Center,
} from '@chakra-ui/react'
import { MdSearch, MdArrowBack, MdGroupAdd, MdSend } from 'react-icons/md'
import { CHAT_PANEL_VIEW } from '../indes'
import { LoadChatData } from '../../../../hooks/asset.hooks'
import { BsSearch } from 'react-icons/bs'
import { useLoadCoWorkersList } from '../../../../hooks/shared.hooks'
import { useAuthContext } from '../../../../context/auth.context'
import { useLanguageContext } from '../../../../context/locale.context'
import { getCurrentDateUTC } from '../../../../utils/common.util'
import SingleChatCard from '../SingleChatCard'
import { useSharedContext } from '../../../../context/shared.context'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../../../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../../../containers/repository/repo.utils'
import bgImage from '../../../../assets/images/opaque_bgImage.png'
import InputText from '../../../globalComponents/inputText'
import ButtonCTA from '../../../globalComponents/button'

const ChatList = ({
	setchatView,
	onProfileSelection,
	user,
	setisNewChat,
	isNewChat,
	chatInitializer,
	//group chat states
	isFromGroup,
	inviteUser,
	groupUsers,
	setGrouplistCount,
}) => {
	const { mutate, isLoading } = LoadChatData()
	const { mutate: loadCoWorkers, isLoading: isworkersLoading } =
		useLoadCoWorkersList()
	const [currUser, setCurrUser] = useState('')
	const [chatData, setchatData] = useState([])
	const [serchString, setserchString] = useState('')
	const [isSerchChange, setisSerchChange] = useState(false)
	const [isGroupChat, setisGroupChat] = useState(false)
	const [dummy, setdummy] = useState(true)
	const [groupList, setGroupList] = useState([])
	const [groupName, setGroupName] = useState('')
	const [isGroupSubmites, setisGroupSubmites] = useState(false)
	const [showSearch, setShowSearch] = useState(false)
	const [groupSearch, setGroupSearch] = useState('')
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const { state, dispatch } = useSharedContext()
	const { isRefreshChat, refreshChatList } = state || {}

	useEffect(() => {
		getChatList()
	}, [isRefreshChat, refreshChatList])

	const getChatList = () => {
		mutate(
			{
				asset_message_counter: 0,
				message_unique_id: 1636353695988,
				track_latitude: 0,
				track_longitude: 0,
				track_altitude: 0,
				track_gps_datetime: getCurrentDateUTC(new Date()),
				track_gps_accuracy: 0,
				track_gps_status: 0,
				page_limit: 50,
				page_start: 0,
			},
			{
				onSuccess: async data => {
					if (isFromGroup) {
						let val = data.filter(
							val =>
								groupUsers.findIndex(
									ele =>
										ele.operating_asset_first_name ===
											val.operating_asset_first_name &&
										ele.operating_asset_phone_number ===
											JSON.parse(val.activity_inline_data).contact_phone_number
								) === -1
						)
						setchatData(val)
					}
					setchatData(data)
				},
				onError: async err => {
					console.log(err)
				},
			}
		)
	}

	const returnUserName = profile => {
		let userName
		if (isSerchChange) {
			userName = profile.operating_asset_first_name
		} else {
			let activityTitle = profile.activity_title.split('-')
			if (user.asset_id === profile.activity_creator_asset_id) {
				//props.loguser
				userName = activityTitle[1]
			} else {
				userName = activityTitle[0]
			}
			if (profile.activity_type_category_id === 27) {
				userName = profile.activity_title
			}
			if (userName === undefined) {
				userName = profile.activity_title
			}
		}
		return userName
	}

	const onSerch = () => {
		loadCoWorkers(
			{
				is_search: 1,
				is_sort: 0,
				is_status: 0,
				limit_value: 50,
				start_from: 0,
				activity_type_category_id: 5,
				search_string: serchString,
			},
			{
				onSuccess: async data => {
					let val
					if (isFromGroup) {
						val = data.filter(
							val =>
								groupUsers.findIndex(
									ele =>
										ele.operating_asset_first_name ===
											val.operating_asset_first_name &&
										ele.operating_asset_phone_number ===
											JSON.parse(val.activity_inline_data).contact_phone_number
								) === -1
						)
					} else {
						val = data.filter(
							val =>
								groupList.findIndex(
									ele => ele.activity_id === val.activity_id
								) === -1
						)
					}
					setchatData(val)
				},
				onError: async err => {
					console.log(err)
				},
			}
		)
	}

	useEffect(() => {
		if (serchString) {
			setisSerchChange(true)
			setisNewChat(true)
			onSerch()
		} else {
			// setisNewChat(false)
		}
	}, [serchString])

	const onGoBack = () => {
		getChatList()
		setserchString('')
		setisNewChat(false)
		setisSerchChange(false)
		setisGroupChat(false)
		setGroupList([])
		setGrouplistCount(0)
		setGroupName('')
		setisGroupSubmites(false)
		setShowSearch(false)
	}

	const onChatListClick = async user => {
		if (isGroupChat) return
		setisNewChat(false)
		onProfileSelection(user)
		chatInitializer(user)
		setchatView(CHAT_PANEL_VIEW.CHAT_VIEW)
		setCurrUser(user.activity_id)
	}

	const onAddGroup = () => {
		typeof setchatView === 'function' && setchatView(CHAT_PANEL_VIEW.LIST_VIEW)
		setchatData([])
		setisGroupChat(true)
		setisSerchChange(true)
		onSerch()
	}
	useEffect(() => {
		if (isFromGroup) {
			onAddGroup()
		}
	}, [groupUsers])

	const addPersonToGroup = item => {
		if (isFromGroup) {
			inviteUser(item)
		} else {
			let data = groupList
			data.push(item)
			setGroupList(data)
			setGrouplistCount(data?.length)
			let val = chatData.filter(
				val =>
					groupList.findIndex(ele => ele.activity_id === val.activity_id) === -1
			)
			setchatData(val)
			setdummy(!dummy)
		}
	}

	const removePersonToGroup = indx => {
		let data = groupList
		data.splice(indx, 1)
		setGroupList(data)
		setGrouplistCount(data?.length)
		setdummy(!dummy)
		onSerch()
	}

	const onGroupCreat = () => {
		setisGroupSubmites(true)
		if (!groupName || !groupList.length) return
		setisNewChat(true)
		setdummy(!dummy)
		let group = {
			groupName: groupName,
			isGroupChat: true,
			userList: groupList,
		}
		chatInitializer(group)
		setchatView(CHAT_PANEL_VIEW.CHAT_VIEW)
		onGoBack()
		setisGroupChat(false)
		setGroupList([])
		setGroupName('')
		setisGroupSubmites(false)
		setisSerchChange(false)
		setserchString('')
	}
	const conversationClick = () => {
		sectionDetailedTrack({
			category: GA_CATEGORY_NAVBAR,
			action: 'Chat List',
			label: 'Create Group',
		})
		dataLayerTagManager('button_click', {
			viewName: 'Chat',
			buttonName: 'Create Group',
		})
		onAddGroup()
		setShowSearch(true)
	}

	const createGroup = () => {
		sectionDetailedTrack({
			category: GA_CATEGORY_NAVBAR,
			action: 'Chat List',
			label: 'Create Group',
		})
		dataLayerTagManager('button_click', {
			viewName: 'Chat',
			buttonName: 'Create Group',
		})
		setchatView(CHAT_PANEL_VIEW.CREATE_GROUP_VIEW)
	}

	const getFilteredSearchChat = () => {
		const filteredData = (chatData || []).reduce(function (
			filtered,
			item,
			index
		) {
			if (
				item.activity_title.toLowerCase().includes(groupSearch.toLowerCase())
			) {
				filtered.push(
					<SingleChatCard
						key={index}
						isGroupChat={isGroupChat}
						index={index}
						currUser={currUser}
						returnUserName={returnUserName}
						item={item}
						onChatListClick={onChatListClick}
						addPersonToGroup={addPersonToGroup}
						isSelected={false}
						removePersonToGroup={removePersonToGroup}
						org={user.organization_id}
					/>
				)
			}
			return filtered
		},
		[])
		if (filteredData.length === 0)
			return <Center>{locale['No data to display']}</Center>
		return filteredData
	}

	return (
		<>
			{isSerchChange ? (
				!isFromGroup && (
					<>
						<Flex alignItems='center' m='5px'>
							<IconButton
								aria-label='Call Segun'
								size='md'
								icon={<MdArrowBack />}
								onClick={() => {
									sectionDetailedTrack({
										category: GA_CATEGORY_NAVBAR,
										action: 'Chat List',
										label: 'Go Back',
									})
									onGoBack()
								}}
							/>
							{/* <Text
                  fontSize="24"
                  alignSelf="flex-end"
                  fontWeight="bold"
                  marginLeft="4"
                >
                  {user?.operating_asset_first_name}-
                </Text> */}
						</Flex>
					</>
				)
			) : (
				<>
					<InputGroup m='0.625rem' size='sm' w='unset'>
						<InputText
							placeholder={locale['Search']}
							_placeholder={{
								color: 'brand.700',
								opacity: '0.6',
							}}
							borderRadius='full'
							border='1px solid #009B76'
							bg={'#FFFFFF'}
							color='black'
							value={groupSearch}
							onChange={e => {
								setGroupSearch(e.target.value)
							}}
							_focus={{
								border: '1px solid #009B76',
								boxShadow: 'none',
							}}
						/>
						<InputRightElement children={<BsSearch color={'green'} />} />
					</InputGroup>
					<Flex
						justifyContent='end'
						alignItems='end'
						marginRight='1'
						marginLeft='3'
						mt='0.625rem'
						mr='0.625rem'
						mb='0.625rem'
					>
						<ButtonCTA
							variant='sidebarButton'
							children={locale['Start a conversation']}
							onClick={createGroup}
							mr='5px'
							mb='0px'
						/>
					</Flex>
				</>
			)}
			{showSearch ? (
				<InputGroup marginTop='2'>
					<InputText
						type='tel'
						width='100%'
						fontSize='13px'
						fontStyle='normal'
						fontWeight='500'
						color='#131D0B'
						placeholder={locale['Search user...']}
						value={serchString}
						onChange={e => {
							dataLayerTagManager('button_click', {
								viewName: 'Chat',
								buttonName: 'Search User',
							})
							setserchString(e.target.value)
						}}
						opacity='0.5'
						borderRadius='18px'
					/>
					<InputRightElement
						pointerEvents='none'
						color='green.500'
						children={<MdSearch fontSize='25' />}
					/>
				</InputGroup>
			) : (
				''
			)}

			<Divider />
			<Flex flexDir='row'>
				<Box
					height='58vh'
					overflowY='auto'
					w={groupList.length ? '43%' : '100%'}
					marginTop={1}
					sx={{
						'&::-webkit-scrollbar': {
							width: '9px',
							height: '50px',
							//backgroundColor: `rgb(0,155,118)`,
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: `rgb(0,155,118)`,
						},
						'&::-webkit-scrollbar-button': {
							height: '12px',
						},
					}}
				>
					{chatData?.length ? (
						getFilteredSearchChat()
					) : isLoading || isworkersLoading ? (
						[1, 2, 3, 4, 5, 6, 7, 8].map(i => {
							return (
								<Skeleton
									boxShadow='md'
									borderRadius='md'
									key={i}
									mb={2}
									w='full'
									h='53px'
								/>
							)
						})
					) : (
						<Text color='black' fontSize='lg' textAlign='center' marginTop='3'>
							{isSerchChange
								? locale['No data to display']
								: locale['No Chat history to display']}
						</Text>
					)}
				</Box>
				<Box
					w={groupList.length ? '85%' : ''}
					mt={groupList.length ? '-120px' : ''}
				>
					{isGroupChat && groupList.length ? (
						<Box height='45%' position='relative'>
							<Text
								fontSize='24px'
								textAlign='center'
								fontWeight='bold'
								marginBottom='3'
								position='sticky'
							>
								Selected Users :- {groupList.length}{' '}
							</Text>

							<Divider />
							<Box
								overflowY='scroll'
								height='65vh'
								backgroundImage={`url(${bgImage})`}
								backgroundColor='#bbbbbb1a'
								sx={{
									'::-webkit-scrollbar': {
										width: '3px',
									},
									'::-webkit-scrollbar-thumb': {
										outline: '1px solid green',
										borderRadius: '50px',
										border: 'solid 3px transparent',
										backgroundClip: 'content-box',
										WebkitBackgroundClip: 'content-box',
									},
								}}
							>
								{(groupList || []).map((item, i) =>
									item.activity_type_category_id !== 27 ? (
										<SingleChatCard
											isGroupChat={isGroupChat}
											index={i}
											key={i}
											returnUserName={returnUserName}
											item={item}
											onChatListClick={onChatListClick}
											addPersonToGroup={addPersonToGroup}
											isSelected={true}
											removePersonToGroup={removePersonToGroup}
										/>
									) : null
								)}
							</Box>
							<Divider />
							{groupList.length >= 1 ? (
								<Box>
									<Flex position='absolute' width='93%' m='18px'>
										<InputText
											placeholder={locale['Enter Group Name']}
											value={groupName}
											onChange={e => setGroupName(e.target.value)}
										/>
										<IconButton
											w='48px'
											h='40px'
											borderRadius='50%'
											bg='brand.700'
											color='#FFFFFF'
											variant=''
											aria-label='Search database'
											marginLeft='2'
											icon={<MdSend />}
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_NAVBAR,
													action: 'Chat List',
													label: locale['Send'],
												})
												onGroupCreat()
											}}
										/>
									</Flex>
									{isGroupSubmites && !groupName ? (
										<Text
											position='absolute'
											marginTop='10'
											bottom='0'
											color='red.400'
										>
											Please enter a Group Name
										</Text>
									) : null}
								</Box>
							) : null}
						</Box>
					) : null}
				</Box>
			</Flex>
		</>
	)
}

export default ChatList
